import React, { memo } from 'react';
import Box from '@mui/material/Box';
import DataObject from '@mui/icons-material/DataObject';

/** Rounded mint tile with the `{}` icon used to mark a spec file. */
const FileGlyph: React.FC<{ size?: number }> = ({ size = 36 }) => (
  <Box
    aria-hidden
    sx={{
      width: size,
      height: size,
      flexShrink: 0,
      borderRadius: 2.5,
      bgcolor: 'brand.container',
      color: 'brand.onContainer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <DataObject sx={{ fontSize: size >= 40 ? 22 : 20 }} />
  </Box>
);

export default memo(FileGlyph);
